
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rivals/[id]/industry-comparison",
      function () {
        return require("private-next-pages/rivals/[id]/industry-comparison.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rivals/[id]/industry-comparison"])
      });
    }
  